import { Star } from "lucide-react";
import { Reveal, Chapter } from "../../lib/motion";
import { TESTIMONIALS } from "../../data";

export default function Testimonials() {
  return (
    <section data-testid="testimonials" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Chapter number="08" overline="Testimonials" title="What our global partners say." />
        <div className="grid md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={0.06 * i}>
              <figure className="h-full rounded-2xl bg-verra-grey border border-verra-blue/10 p-8">
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: t.rating }).map((_, s) => (
                    <Star key={s} className="w-4 h-4 fill-verra-green text-verra-green" />
                  ))}
                </div>
                <blockquote className="font-display text-xl md:text-2xl text-verra-blue leading-snug">“{t.text}”</blockquote>
                <figcaption className="mt-6">
                  <p className="font-semibold text-verra-blue">{t.name}</p>
                  <p className="text-sm text-verra-green">{t.company}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
